module.exports = __webpack_public_path__ + "static/media/IMG_1816.55f6fdcc.JPG";